module.exports = __webpack_public_path__ + "img/5.4cab8dc4.png";